module.exports = __webpack_public_path__ + "static/media/weiss_thumb_even.6df936bd.webp";